<template>
  <div class="step">
    <div class="step--heading" :class="{ active: product_items.length > 0 }">
      <div class="inner">
        <span>{{ step_count }}</span>
        <p>{{ label_products }}</p>
      </div>
    </div>
    <div class="step--body" v-show="product_items.length > 0">
      <div class="row">
        <div class="col-12" v-for="(bar, index) in barItems" :key="index">
          <div v-if="bar">
            <h3 v-if="bar.bars == 1 && product_type == 'racks'">{{ bar.bars }} {{ label_Bar }}</h3>
            <h3 v-if="bar.bars > 1 && product_type == 'racks'">{{ bar.bars }} {{ label_Bars }}</h3>
            <div class="col-12" v-for="(product) in bar.items" :key="product.stockCode">
              <a :href="culture +'/product/' + product.stockCode">
                <div class="product">
                  <div class="header">
                    <div class="image">
                      <img :src="product.p_r_medias[0].mediaUrl" alt />
                    </div>

                    <div class="details">
                      <div>
                        <h3>{{ product.title }}</h3>
                        <p>{{ product.stockCode }}</p>
                        <div class="features" v-if="hasSpecificationFeatures(product)">
                          <div
                            v-for="feature in specificationFeatures(product)"
                            :key="feature.id"
                            :class="feature.value.toLowerCase()"
                          >
                            <i :class="'icon icon-' + feature.value.toLowerCase()"></i>
                            {{ feature.name }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="pricing">
                      <div>
                        <div>{{ product.productPrice }} {{ currency_suffix}} {{ int_curr_symbol }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import minMaxPricing from "../../mixins/min-max-pricing.js";

export default {
  name: "products",
  mixins: [minMaxPricing],
  props: {
    product_items: Array,
    step_count: Number,
    currency_suffix: String,
    int_curr_symbol: String,
    product_type: String,
    label_complete_kit: {
      type: String,
      default: "Complete Kit"
    },
    label_whats_included: {
      type: String,
      default: "What's Included"
    },
    label_qty: {
      type: String,
      default: "Qty"
    },
    label_view: {
      type: String,
      default: "View"
    },
    label_solution: {
      type: String,
      default: "Solution"
    },
    label_products: {
      type: String,
      default: "Products"
    },
    label_Bar: {
      type: String,
      default: "Bar"
    },
    label_Bars: {
      type: String,
      default: "Bars"
    }
  },
  data() {
    return {
      culture: window.culture ? "/" + window.culture : "",
    }
  },
  methods: {
    hasSpecificationFeatures(product) {

        let hasSpecificationFeatures = false;

        this.specificationFeatures(product).forEach((feature, index) => {
            if(feature.value.toLowerCase() === 'yes'){
                hasSpecificationFeatures = true;
            }
        });

        return hasSpecificationFeatures;

    },
    specificationFeatures(product) {
      var features = [];
      for (
        var i = 0;
        i < product.product_specification_properties.length;
        i++
      ) {
        if (
          product.product_specification_properties[i]
            .specification_property_master_data
        ) {
          for (
            var ii = 0;
            ii <
            product.product_specification_properties[i]
              .specification_property_master_data.features.length;
            ii++
          ) {
            var item =
              product.product_specification_properties[i]
                .specification_property_master_data.features[ii];
            if (["Yes", "No"].indexOf(item.value) > -1) {
              features.push(item);
            }
          }
        }
      }
      return features;
    }
  },
  computed: {
    barItems() {
      var items = [{ bars: 0, items: [] }];
      for (var i = 0; i < this.product_items.length; i++) {
        if (this.product_items[i].SpecificationProperties["# Of Bars Included"]) {
          if (
            !items[
              this.product_items[i].SpecificationProperties["# Of Bars Included"][
                "# Of Bars Included"
              ]
            ]
          ) {
            items[
              this.product_items[i].SpecificationProperties["# Of Bars Included"][
                "# Of Bars Included"
              ]
            ] = {
              bars: this.product_items[i].SpecificationProperties["# Of Bars Included"][
                "# Of Bars Included"
              ],
              items: []
            };
          }
          items[
            this.product_items[i].SpecificationProperties["# Of Bars Included"][
              "# Of Bars Included"
            ]
          ].items.push(this.product_items[i]);
        } else {
          items[0].items.push(this.product_items[i]);
        }
      }
      return items.sort(function(a, b) {
        if (a.bars > b.bars) {
          return -1;
        } else if (a.bars < b.bars) {
          return 1;
        } else {
          return 0;
        }
      });
    }
  }
};
</script>

<style lang="scss">
.product {
  border: 1px solid #ebebeb;
  background-color: white;
  margin-bottom: 20px;
  a {
    color: black;
  }
}
</style>
